// Version des geladenen Stands (Zeitpunkt des Snapshots, GET /matrix): der
// Ergebnis-Link traegt sie, damit er auch nach erneutem Einfrieren seinen
// Stand laedt (Spec 2026-10-06, 3.5). Kommt mit dem Snapshot und aendert sich nie.
const versionReducer = (state = null) => state

export default versionReducer
